import { render, staticRenderFns } from "./CytomineProperties.vue?vue&type=template&id=1b8327b6&scoped=true&"
import script from "./CytomineProperties.vue?vue&type=script&lang=js&"
export * from "./CytomineProperties.vue?vue&type=script&lang=js&"
import style0 from "./CytomineProperties.vue?vue&type=style&index=0&id=1b8327b6&scoped=true&lang=css&"
import style1 from "./CytomineProperties.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8327b6",
  null
  
)

export default component.exports